import { makeAutoObservable } from "mobx";
import { State } from "../enum/state";
import http from "../services/http";

export default class CouponsStore {
  data?: IObject[];
  item?: IObject;
  state: State = "None";
  isLoading = false;
  search = "";

  get filteredResults() {
    if (this.search === "") {
      return this.data;
    }

    return this.data?.filter((e) =>
      `${e.user} ${e.value} ${e.user?.profile.lastName} ${e.user?.profile.firstName} ${e.user?.email} `
        .toLowerCase()
        .includes(this.search.toLowerCase())
    );
  }

  async findAll() {
    const result = await http.get("coupons");
    this.data = result.data.data;
  }

  async findOne(id: string) {
    this.isLoading = true;
    try {
      const result = await http.get(`coupons/${id}`);
      this.item = result.data.data;
    } finally {
      this.isLoading = false;
    }
  }

  async onCreate(values: any) {
    this.isLoading = true;
    try {
      await http.post("coupons", values);
      this.state = "None";
    } finally {
      this.isLoading = false;
    }
  }

  async onUpdate(values: any) {
    this.isLoading = true;
    try {
      await http.put(`coupons/${this.item?.id}`, values);
      this.state = "None";
    } finally {
      this.isLoading = false;
    }
  }

  async onRemove(id: string) {
    this.isLoading = true;
    try {
      await http.delete(`coupons/${id}`);
      if (this.data) this.data = this.data.filter((e) => e.id !== id);
    } finally {
      this.isLoading = false;
    }
  }

  generatePromoCode(length: number = 8): string {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let promoCode = "";
    for (let i = 0; i < length; i++) {
      promoCode += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return promoCode;
  }

  constructor() {
    makeAutoObservable(this);
  }
}

interface IObject {
  id: string;
  value: string;
  note: string;
  createdAt: Date;
  expirationDate: Date;
  user?: {
    email: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
}
